import posthog from "posthog-js";
import { env } from "./env";

let analyticsInitialized = false;

export function initAnalytics() {
  if (analyticsInitialized || !env.posthogKey) {
    if (!analyticsInitialized && !env.posthogKey) {
      console.warn("[analytics] VITE_POSTHOG_KEY missing; analytics disabled");
    }
    return;
  }

  posthog.init(env.posthogKey, {
    api_host: env.posthogHost,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: "localStorage",
  });

  analyticsInitialized = true;
}

type ClientErrorPayload = {
  source: string;
  message: string;
  error?: unknown;
  data?: Record<string, unknown>;
};

export async function logClientError(payload: ClientErrorPayload) {
  console.error(`[client-error] ${payload.source}: ${payload.message}`, payload.error ?? payload.data);

  initAnalytics();

  if (analyticsInitialized) {
    posthog.capture("client_error", {
      source: payload.source,
      message: payload.message,
      ...payload.data,
    });
  }

  if (env.monitorEndpoint && env.monitorToken) {
    try {
      await fetch(env.monitorEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${env.monitorToken}`,
        },
        body: JSON.stringify({
          ...payload,
          timestamp: new Date().toISOString(),
        }),
        keepalive: true,
      });
    } catch (monitorError) {
      console.warn("[monitor] failed to forward client error", monitorError);
    }
  }
}
